import React from 'react';
import SarasListItem from '../../../library/repeater/list/SarasListItem';
import Icon from '../../../library/decor/SarasIcons';

const SarasDrawerMenuItem = ({menuRow, onClick}) => {
  
  function handleParentClick(e, itemRef) {
    if(onClick){
      onClick(menuRow, itemRef);
    }
  }

  const MIcon = Icon[menuRow.MenuIcon];
    
  return (
    <SarasListItem onclick={handleParentClick} title={menuRow.MenuTitle} 
      ListIcon={MIcon} iconClass={`${menuRow.MenuType === 'f' ? 'saras-tour-home-side-menu-recent' : ''} uiAppIcon uiMenuItem`} >
    </SarasListItem>
  )
}

export default SarasDrawerMenuItem;
